// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import VitaloraAgentsActivity from "./activityView";

import PendingComponent from "../../components/PendingComponent";
import { isDemoEnterprise } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";

export const vitaloraAgentsActivityRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "agents/activity",
  beforeLoad() {
    if (!isDemoEnterprise()) {
      throw redirect({ to: "/" });
    }
  },
  component: VitaloraAgentsActivity,
  pendingComponent: PendingComponent,
});
